@if(isWideScreen){
<app-desktop-view></app-desktop-view>
}@else {
<app-lot-item></app-lot-item>
}
<router-outlet></router-outlet>
